import MarkDownRenderer from '../../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
## **Request Body Types**

HawkClient supports multiple request body formats to handle different API requirements.

### **JSON**
Structured JSON data commonly used in REST APIs.

### **GraphQL**
Send GraphQL queries and mutations with:
- Schema fetching
- Auto-complete query suggestions

![GraphQL Request Body](/send-requests/GraphQL.png)

### **form-data**
Used for file uploads or multipart key-value pairs.

### **x-www-form-urlencoded**
URL-encoded key-value pairs, typically used in form submissions.

### **Text**
Plain text request bodies.

### **XML**
Send raw XML payloads for SOAP or XML-based APIs.
`;

const BodyTab = () => {
    return (
        <MarkDownRenderer
            title="Request Body"
            markDownText={markdownContent}
        />
    );
};

export default BodyTab;
